<script>
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  const { checkPropTypes, object } = PropTypes;
  import SvgLike from "$assets/svg/like.svg?src";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import { timeSince } from "@/utils";
  import constants from "@/constants";

  export let comment;

  const propTypes = {
    comment: object,
  };

  const smallTextClasses = `text-[12px] md:text-[15px] text-[#8a8a8f]`;
  const { DEFAULT_USER_PIC } = constants;

  const maxLines = 2;
  let maxHeight = 0;
  let clipText = false;
  let seeMore = false;
  let commentBox;

  $: maxHeightStyle = seeMore ? `max-height:${maxHeight}px` : "";

  const toggleSeeMore = () => {
    seeMore = !seeMore;
  };

  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Comment");
    // Multi line truncation
    const { height } = commentBox.getBoundingClientRect();
    const lineHeight = parseFloat(getComputedStyle(commentBox).lineHeight);
    maxHeight = lineHeight * maxLines;
    if (height > maxHeight + lineHeight / 2) {
      clipText = true;
      seeMore = true;
    }
    //
  });
</script>

<div class="flex m-md">
  <div class="relative">
    <a href={`/@${comment.ah}?referrer=web`} class="flex w-2xl">
      <img
        src={comment.ap || DEFAULT_USER_PIC}
        class="rounded-[50%] h-2xl w-2xl bg-cover bg-light-grey object-cover lazyload"
        alt={comment.an}
        width="48"
        height="48"
      />
    </a>
  </div>
  <div class="ml-lmg grow">
    <div class="flex items-center justify-between">
      <div class="p-xs bg-bg-secondary-moj rounded-lg" style="">
        <div class={`flex items-center ${smallTextClasses}`}>
          <a href={`/@${comment.ah}?referrer=web`}>@{comment.ah}</a>
          {#if comment.badgeUrl}
            <img class="h-md w-md ml-xxs" src={comment.badgeUrl} alt="Badge" />
          {/if}
        </div>
        <div
          bind:this={commentBox}
          class={seeMore ? `overflow-hidden` : ""}
          style={`overflow-wrap:anywhere;${maxHeightStyle}`}
        >
          {comment.m}
        </div>
        {#if clipText}
          <div
            on:click={toggleSeeMore}
            class="font-bold text-secondary-text-moj cursor-pointer"
          >
            {seeMore ? "...see more" : "...less"}
          </div>
        {/if}
      </div>
      <div class="mx-xs text-center">
        <SvgWrapper svg={SvgLike} className="h-lg w-lg text-primary-text-moj" />
        <div class={`${smallTextClasses} text-white`}>{comment.l}</div>
      </div>
    </div>
    <div class={`${smallTextClasses} mt-xs ml-xs`}>
      <span>{timeSince(comment.t * 1000, true)}</span>
      {#if comment.likedByPostAuthor}
        Liked by Author
      {/if}
    </div>
  </div>
</div>
